/* import __COLOCATED_TEMPLATE__ from './bridge-chart-edit.hbs'; */
/* RESPONSIBLE TEAM: team-reporting */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { getOwner } from '@ember/application';
import type RouterService from '@ember/routing/router-service';
import type ReactTeammateAppIslandService from 'embercom/services/react-teammate-app-island';
import type ApplicationInstance from '@ember/application/instance';
import { registerDestructor } from '@ember/destroyable';

interface Signature {
  Args: {};
}

export default class ReportingCustomReportBridgeChartEdit extends Component<Signature> {
  @service declare router: RouterService;
  @service declare reactTeammateAppIsland: ReactTeammateAppIslandService;

  constructor(owner: ApplicationInstance, args: {}) {
    super(owner, args);
    let unsubscribe = this.reactTeammateAppIsland.subscribeToTeammateAppEvent(
      'reporting:chart:edit',
      (data: { chartId: string }) => {
        this.navigateToChartEdit(data.chartId);
      },
    );

    registerDestructor(this, () => {
      unsubscribe();
    });
  }

  private navigateToChartEdit(chartId: string) {
    let isStandalone = this.router.currentRouteName?.startsWith('apps.app.standalone');

    let showRouteName = isStandalone
      ? 'apps.app.standalone.reports.report.show'
      : 'apps.app.reports.custom-reports.report.show';
    let showRoute = (getOwner(this) as ApplicationInstance | undefined)?.lookup(
      `route:${showRouteName}`,
    ) as { enableEditMode?: (enable: boolean, refreshState: boolean) => void } | undefined;
    showRoute?.enableEditMode?.(true, false);

    let editRoute = isStandalone
      ? 'apps.app.standalone.reports.report.show.chart.edit'
      : 'apps.app.reports.custom-reports.report.show.chart.edit';

    let queryParams: Record<string, unknown> = { cr2AddingChartToReport: true };
    if (isStandalone) {
      queryParams.isStandalone = true;
    }

    this.router.transitionTo(editRoute, chartId, { queryParams });
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Custom::Report::BridgeChartEdit': typeof ReportingCustomReportBridgeChartEdit;
    'reporting/custom/report/bridge-chart-edit': typeof ReportingCustomReportBridgeChartEdit;
  }
}
